import MBlocksDesigner from '@admin/components/mblocks_designer/wrapper'
import Translate from '@apps/maha/admin/components/translate'
import MJSONDesigner from '@admin/components/mjson_designer'
import { canAccess } from '@core/utils/access'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import React from 'react'

class Designer extends React.Component {

  static contextTypes = {
    admin: PropTypes.object
  }

  static propTypes = {
    email: PropTypes.object
  }

  render() {
    const { email } = this.props
    return (
      <>
        { email.engine === 'mblocks' ?
          <MBlocksDesigner { ...this._getMBlocksDesigner() } /> :
          <MJSONDesigner { ...this._getMJSONDesigner() } />
        }
      </>
    )
  }

  _getMBlocksDesigner() {
    const { admin } = this.context
    const { email } = this.props
    return {
      defaultValue: email.config,
      editable: canAccess({ 
        programs: { $canEdit: email.program.id },
        rights: { $allOf: ['automation:manage_workflows'] } 
      }, admin),
      email,
      endpoint: `/api/admin/automation/emails/${email.id}`,
      program: email.program,
      tokens: this._getTokens()
    }
  }

  _getMJSONDesigner() {
    const { admin } = this.context
    const { email } = this.props
    return {
      editable: canAccess({ 
        programs: { $canEdit: email.program.id },
        rights: { $allOf: ['automation:manage_workflows'] } 
      }, admin),
      endpoint: `/automation_emails/${email.id}`,
      root_route: `/automation/emails/${email.id}/design`,
      type: 'email',
      versionable: true
    }
  }

  _getEmailDesigner() {
    const { email } = this.props
    return {
      defaultValue: email.config,
      endpoint: `/api/admin/automation/emails/${email.id}`,
      program: email.program,
      tokens: this._getTokens()
    }
  }

  _getTokens() {
    const { event, form } = this.props.email.workflow
    if(form) return this._getResponseTokens(form)
    return []
  }

  _getPaymentTokens(model) {
    return {
      title: 't(Payment Tokens)',
      tokens: [
        { name: 'Method', token: `${model}.payment_method` },
        { name: 'Amount', token: `${model}.payment_amount` },
        { name: 'Card', token: `${model}.payment_card` },
        { name: 'Summary', token: `${model}.payment_summary` }
      ]
    }
  }

  _getResponseTokens(form) {
    return [
      {
        title: 't(Response Tokens)',
        tokens: [
          ...form.config.fields.filter(field => {
            return !_.includes(['text'], field.type)
          }).map(field => ({
            name: field.name.value,
            token: `response.${field.name.token}`
          }))
        ]
      },
      this._getPaymentTokens('response')
    ]
  }
}

const mapPropsToPanel = (props, context) => ({
  title: 't(Design)',
  component: <Designer email={ props.email } />,
  tasks: {
    items: [
      {
        label: 't(Translate Email)',
        svg: 'flag',
        modal: <Translate entity_type='automation_emails' entity_id={ props.email.id } mjson_type='email' publish={ true } />
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
